import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  IonCheckbox,
  IonItem,
  IonList,
  IonLabel,
  IonRadio,
  IonRadioGroup,
  IonButton,
  IonIcon,
  IonAlert,
  IonTextarea,
  IonRow,
} from '@ionic/react';
import { arrowBack, chevronDown, chevronUp } from 'ionicons/icons';
import Layout from '../../components/layout';
import Incrementer from '../../components/incrementer';
import Pullup from '../../components/pullup';
import {
  Title,
  Sectiontitle,
  SmallText,
  Spacer,
  FlexSpacer,
  Hr,
  NormalText,
  StrongText,
} from '../../components/common';
import { withTranslation } from '../../lib/translate';
import Basket from '../../lib/basket';
import {
  makeKey,
  isDefined,
  deepCopy,
  goBack,
  isWebConfig,
  forwardTo,
  isEmptyObject,
  parseAllergenData,
  isObject,
  isTaxActiveForOrderType,
  getItemTax,
  doesItemHaveTax,
} from '../../lib/utils';
import { PillGroup } from '../../components/pill';
import { storeItemWeb } from '../../store/actions';
import { getConfig } from '../../appConfig';
import './index.css';

const {
  formatPrice,
  _calculateItemPrice,
  validateItem,
  addToBasket,
  getProductName,
  getProductDescription,
  isProductEnabled,
  isChoicesGroupValid,
  setAllergen,
} = Basket;

const noImage = () => <div className="item-details-background"></div>;
var nestedModifiersErrors = []
class itemDetailsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      price: 0,
      selectedChoices: [],
      selectedSubChoices: [],
      validationErrors: [],
      nestedValidationErrors: [],
      instructions: '',
      showValidationAlert: false,
      allergensCodes: [],
      nutritionalInfoVisible: false,
      ingredientsVisible: false,
      nameVisible: true,
      excludeTaxes: false,
      orderType: '',
    };
  }

  componentDidMount() {
    const { profile, allergens, item } = this.props;
    let quantity = this.state.quantity;
    let selectedChoices = [];
    let validationErrors = [];
    let selectedSubChoices = []
    let nestedValidationErrors = []

    if (item.menuDealGroups && item.menuDealGroups.length > 0) {
      selectedChoices = Array(item.menuDealGroups.length).fill([]);
      validationErrors = Array(item.menuDealGroups.length).fill(null);
      selectedSubChoices = Array(item.menuDealGroups.length).fill([]);
      nestedValidationErrors = Array(item.menuDealGroups.length).fill([]);

    }
    for (let i = 0; i < item.menuDealGroups?.length; i++) {
      if (item.menuDealGroups[i].bundleModifiers) {
        selectedSubChoices[i] = item.menuDealGroups[i].bundleModifiers.map(sub => sub.map(() => []))
        nestedValidationErrors[i] = item.menuDealGroups[i].bundleModifiers.map(sub => sub.map(() => ({ error: false })))
      }
    }
    nestedModifiersErrors = nestedValidationErrors

    let price = _calculateItemPrice({ item, quantity });
    let newArr = parseAllergenData(profile, item, allergens);
    const basketInstance = this.props.basketInstance || Basket;
    const orderType = basketInstance.getOrderTypeRaw();
    const excludeTaxes = profile.is_corporate
      ? isTaxActiveForOrderType(orderType)
      : doesItemHaveTax(item);
    this.setState({
      price,
      selectedChoices,
      validationErrors,
      allergensCodes: newArr,
      excludeTaxes,
      orderType,
      selectedSubChoices,
      nestedValidationErrors
    });

    let updatedDefaultSelectedOption = deepCopy(selectedChoices);
    const menuDealGroups = item.menuDealGroups ? item.menuDealGroups : [];
    {
      menuDealGroups.map((menuGroupItem, index) => {
        const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
        updatedDefaultSelectedOption = this.drawDefaultGroupChoices(
          updatedDefaultSelectedOption,
          menuGroupItem,
          multiSelectionPermitted,
          index,
        );
        if (menuDealGroups.length - 1 === index) {
          this.setDefaultOption(updatedDefaultSelectedOption);
        }
      });
    }
  }

  onIncrementerUpdate = (newQuantity) => {
    this.setState({
      quantity: newQuantity,
      price: _calculateItemPrice({
        item: this.props.item,
        quantity: newQuantity,
        selectedChoices: this.state.selectedChoices,
      }),
    });
  };

  handleInputChange = (groupIndex, sku, multiSelectionPermitted, event, choiceIndex) => {
    const isBundle = false
    const item = this.props.item;
    const { quantity, selectedChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup && sku !== null) {
      let selectedChoice = selectedGroup.items.find((i) => i.sku === sku);
      selectedChoice.quantity = 1
      if (!selectedChoice) {
        allGroups[groupIndex].bundleModifiers.every((product) => {
          if (product.length > 0) {
            product.every((modifierGroup) => {
              if (modifierGroup && modifierGroup.items.length > 0) {
                modifierGroup.items.every((modifier) => {
                  if (modifier) {
                    if (modifier.sku === sku) {
                      selectedChoice = modifier;
                      return false;
                    }
                    return true;
                  } else {
                    return true;
                  }
                });
              } else {
                return true;
              }
            });
          } else {
            return true;
          }
        });
      }
      let updatedSelectedChoices = deepCopy(selectedChoices);
      if (multiSelectionPermitted) {
        if (event.target.checked) {
          updatedSelectedChoices[groupIndex].push(selectedChoice);

        } else {
          this.setState(prevState => {
            const { selectedSubChoices } = prevState;

            const newData = [...selectedSubChoices];
            newData[groupIndex] = [...newData[groupIndex]];

            newData[groupIndex][choiceIndex] = newData[groupIndex][choiceIndex].map(() => []);
            nestedModifiersErrors[groupIndex][choiceIndex] = nestedModifiersErrors[groupIndex][choiceIndex].map(() => [{ error: false }])
            return { selectedSubChoices: newData };
          });
          updatedSelectedChoices[groupIndex] = updatedSelectedChoices[groupIndex].filter(
            (i) => i.sku !== selectedChoice.sku,
          );
        }
      } else {
        if (!selectedChoice) {
          if (!isBundle) {
            if (updatedSelectedChoices[groupIndex].length > 1) {
              updatedSelectedChoices[groupIndex] = [updatedSelectedChoices[groupIndex][0]];
            } else {
              updatedSelectedChoices[groupIndex] = [];
            }
          } else {
            updatedSelectedChoices[groupIndex] = [updatedSelectedChoices[groupIndex][0]];
          }
        } else {
          if (!isBundle) {
            this.setState(prevState => {
              const newSelected = [...prevState.selectedSubChoices];
              newSelected[groupIndex] = this.clearDeepArrays(prevState.selectedSubChoices[groupIndex]);
              return { selectedSubChoices: newSelected };
            }, () => {
              nestedModifiersErrors[groupIndex] = this.clearDeepArrays(nestedModifiersErrors[groupIndex])
            });
            if (!updatedSelectedChoices[groupIndex].find((i) => i.sku === selectedChoice.sku))
              updatedSelectedChoices[groupIndex] = [selectedChoice];
          } else {
            updatedSelectedChoices[groupIndex].push(selectedChoice);
          }
        }
      }
      this.setState({ selectedChoices: updatedSelectedChoices }, () => {
        const { selectedChoices } = this.state;
        //recalculate item price on every menu deal choice change
        this.setState(
          { price: _calculateItemPrice({ item, quantity, selectedChoices }, true) },
          () => {
            const validationErrors = validateItem(this.constructBasketItem());
            this.setState({ validationErrors: validationErrors.errors });
          },
        );
      });
    }
  };
  clearDeepArrays(arr) {
    if (!Array.isArray(arr)) return arr;
    const containsOnlyNonArrays = arr.every(el => !Array.isArray(el));

    if (containsOnlyNonArrays) {
      return [];
    }

    return arr.map(el => this.clearDeepArrays(el));
  }
  handleSubItem = (
    groupIndex,
    modifier,
    multiSelectionPermitted,
    isChecked,
    isBundle = false,
    selectedGroupIndex,
  ) => {
    const sku = modifier.sku;
    const item = this.props.item;
    let { quantity, selectedChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    let updateState = true;
    if (selectedGroup && sku !== null) {
      let selectedChoice = selectedGroup.items.find((i) => i.sku === sku);
      let selectedItemWithSubItems;
      if (!selectedChoice) {
        selectedChoice = modifier;
        selectedItemWithSubItems = selectedGroup.items[selectedGroupIndex];
      }
      let updatedSelectedChoices = deepCopy(selectedChoices);
      if (multiSelectionPermitted) {
        //checkbox
        if (isChecked) {
          updatedSelectedChoices[groupIndex].forEach((item) => {
            if (!item.subItems) {
              item.subItems = [];
            }
            if (
              item.sku === selectedItemWithSubItems.sku &&
              !item.subItems.find((subItem) => subItem.sku === selectedChoice.sku)
            ) {
              item.subItems.push(selectedChoice);
              updateState = true;
            } else {
              updateState = false;
            }
          });
        } else {
          updatedSelectedChoices[groupIndex].forEach((item) => {
            if (!item.subItems) {
              item.subItems = [];
            }
            if (item.sku === selectedItemWithSubItems.sku) {
              item.subItems = item.subItems.filter((subItem) => subItem.sku !== selectedChoice.sku);
            }
            updateState = true;
          });
        }
      } else {
        //radio
        if (!selectedChoice) {
          if (!isBundle) {
            if (updatedSelectedChoices[groupIndex].length > 1) {
              updatedSelectedChoices[groupIndex] = [updatedSelectedChoices[groupIndex][0]];
            } else {
              updatedSelectedChoices[groupIndex] = [];
            }
          } else {
            updatedSelectedChoices[groupIndex] = [updatedSelectedChoices[groupIndex][0]];
          }
        } else {
          if (!isBundle) {
            if (!updatedSelectedChoices[groupIndex].find((i) => i.sku === selectedChoice.sku))
              updatedSelectedChoices[groupIndex] = [selectedChoice];
          } else {
            updatedSelectedChoices[groupIndex].push(selectedChoice);
          }
        }
      }
      if (updateState) {
        const price = _calculateItemPrice(
          { item, quantity, selectedChoices: updatedSelectedChoices },
          true,
        );
        this.setState(
          {
            selectedChoices: updatedSelectedChoices,
            price: price,
          },
          () => {
            const validationErrors = validateItem(this.constructBasketItem());
            this.setState({ validationErrors: validationErrors.errors });
          },
        );
      }
    }
  };

  setDefaultOption = (updatedDefaultSelectedOption) => {
    const item = this.props.item;
    const { quantity } = this.state;

    this.setState({ selectedChoices: updatedDefaultSelectedOption }, () => {
      const { selectedChoices } = this.state;
      //recalculate item price on every menu deal choice change
      this.setState({ price: _calculateItemPrice({ item, quantity, selectedChoices }) }, () => {
        const validationErrors = validateItem(this.constructBasketItem());
        this.setState({ validationErrors: validationErrors.errors });
      });
    });
  };

  drawDefaultGroupChoices = (
    updatedDefaultSelectedOption,
    menuGroupItem,
    multiSelectionPermitted,
    groupIndex,
  ) => {
    const choices = menuGroupItem.items || [];
    const { selectedChoices } = this.state;
    choices.map((item) => {
      const { defaultQuantity } = item;
      let isOptionSelected = (selectedChoices[groupIndex] || []).find((i) => {
        return isObject(i);
      });
      if (defaultQuantity && !isOptionSelected) {
        if (multiSelectionPermitted) {
          //checkbox
          updatedDefaultSelectedOption[groupIndex].push(item);
        } else {
          //radio
          if (!item) {
            updatedDefaultSelectedOption[groupIndex] = [];
          } else {
            updatedDefaultSelectedOption[groupIndex] = [item];
          }
        }
      }
    });
    return updatedDefaultSelectedOption;
  };
  onIncrementerChoiceUpdate = (newQuantity, data) => {
    const { item } = this.props;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[data.groupIndex];
    if (selectedGroup) {
      this.updateSelectedChoices(
        data.groupIndex,
        data.choiceIndex,
        data.multiSelectionPermitted,
        newQuantity > 0,
        newQuantity,
      );
    }
  };
  updateSelectedChoices = (
    groupIndex,
    choiceIndex,
    multiSelectionPermitted,
    selected = true,
    quantity = 0,
  ) => {
    // const item = this.props.location.state
    const { item } = this.props;
    const { selectedChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[choiceIndex]
        ? deepCopy(selectedGroup.items[choiceIndex])
        : {};
      let updatedSelectedChoices = deepCopy(selectedChoices);
      let selectedChoiceIndex = -1;
      const existingChoice = updatedSelectedChoices[groupIndex].find((i, index) => {
        if (selectedChoice && i.sku === selectedChoice.sku) {
          selectedChoiceIndex = index;
          return true;
        }
        return false;
      });
      if (multiSelectionPermitted) {
        //checkbox
        if (selected) {
          selectedChoice.quantity = 1;
          if (existingChoice) {
            existingChoice.quantity = quantity;
            if (
              selectedChoiceIndex !== -1 &&
              updatedSelectedChoices[groupIndex] &&
              updatedSelectedChoices[groupIndex][selectedChoiceIndex]
            ) {
              updatedSelectedChoices[groupIndex][selectedChoiceIndex] = existingChoice;
            }
          } else {
            updatedSelectedChoices[groupIndex].push(selectedChoice);
          }
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = updatedSelectedChoices[groupIndex].filter(
            (i) => i.sku !== selectedChoice.sku,
          );
        }
      } else {
        if (selected) {
          selectedChoice.quantity = quantity;
          updatedSelectedChoices[groupIndex] = [selectedChoice];
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = [];
        }
      }

      this.setState({ selectedChoices: updatedSelectedChoices }, () => {
        const { selectedChoices } = this.state;
        const newCalculatedPrice = _calculateItemPrice({
          item,
          quantity: this.state.quantity,
          selectedChoices,
        });
        this.setState(
          {
            price: _calculateItemPrice({
              item,
              quantity: this.state.quantity,
              selectedChoices,
            }),
          },
          () => {
            if (this.props.priceUpdated) {
              this.props.priceUpdated(newCalculatedPrice);
            }
            const validationErrors = validateItem(this.constructBasketItem());
            this.setState({ validationErrors: validationErrors.errors });
          },
        );
      });
    }
  };
  drawGroupChoices = (menuGroupItem, multiSelectionPermitted, groupIndex) => {
    const choices = menuGroupItem.items || [];
    const { multiMax, max } = menuGroupItem
    const bundleModifiers = menuGroupItem.bundleModifiers || [];
    for (let i = 0; i < choices?.length; i++) {
      if (bundleModifiers?.[i]) {
        choices[i].subModifiers = bundleModifiers[i];
      }
    }
    const { selectedChoices, orderType } = this.state;
    const { profile, __ } = this.props;
    const allChoices = choices.map((item, choiceIndex) => {
      const { sku } = item;
      const excludeTaxes = profile.is_corporate
        ? isTaxActiveForOrderType(orderType)
        : doesItemHaveTax(item);
      let productPrice = item.productPrice;
      if (excludeTaxes) {
        productPrice = parseFloat(getItemTax(item, orderType)?.calculatedTaxPrice || 0);
      }
      const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => {
        return i.sku === sku;
      });
      if (item.sku === undefined || !isProductEnabled(item)) {
        return <span key={item.sku + '_disabled'} />;
      }
      let groupQunatity = 0;
      (selectedChoices[groupIndex] || []).forEach((i) => {
        groupQunatity += isDefined(i.quantity) ? i.quantity : 1;
      });
      let quantity = 0;
      if (selectedChoices[groupIndex]) {
        const _choice = selectedChoices[groupIndex].find((i) => i.sku === sku);
        quantity = _choice ? _choice.quantity : 0;
      }
      const shouldBeDisabled =
        isDefined(menuGroupItem.max) &&
        menuGroupItem.max > 0 &&
        isDefined(selectedChoices[groupIndex]) &&
        groupQunatity >= menuGroupItem.max &&
        !isChecked;

      return (
        <>
          {max > 1 && multiMax > 1 ?
            <div className='multimax-wrapper'>
              <IonItem
                disabled={multiSelectionPermitted ? shouldBeDisabled : false}
                lines="none"
                key={makeKey(choiceIndex, sku, groupIndex)}
                onClick={() => {
                  if (multiSelectionPermitted) {
                    this.handleInputChange(groupIndex, sku, multiSelectionPermitted, { target: { checked: !isChecked } }, choiceIndex);
                  } else {
                    this.handleInputChange(groupIndex, sku, multiSelectionPermitted, { target: { value: choiceIndex } }, choiceIndex);
                  }
                }}
              >
                <div tabIndex="-1"></div>

                {multiSelectionPermitted ? (
                  <IonCheckbox
                    color="secondary"
                    slot="start"
                    checked={isChecked}

                  />
                ) : (
                  <IonRadio
                    slot="start"
                    className="details-radio"
                    color={'secondary'}
                    value={sku}
                    checked={isChecked}
                    name="modifier-group"
                  />
                )}
                <IonLabel className="ion-text-wrap">
                  <Sectiontitle className="single-item item-details-product-label">
                    {__(getProductName(item, profile))}
                  </Sectiontitle>
                  <p>{formatPrice(productPrice)}</p>

                  {isDefined(item.itemRichData) &&
                    isDefined(item.itemRichData.allergenCodes) &&
                    item.itemRichData.allergenCodes.length > 0 ? (
                    <>
                      <SmallText className='block capitalize '><span className='primary-color'>{__('Allergens')}: </span>{item.itemRichData.allergenCodes.join(' • ')}</SmallText>
                    </>
                  ) : null}
                </IonLabel>



              </IonItem>
              <div className="multimax-price-increment-content" >

                {quantity >= 1 && max > 1 && multiMax > 1 ? (
                  <div
                    className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                  >
                    <Incrementer
                      {...(isWebConfig() && { allowInput: true })}
                      allowNegative={false}
                      data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                      disabled={shouldBeDisabled}
                      maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQunatity)}
                      onUpdate={this.onIncrementerChoiceUpdate}
                      quantity={quantity || 0}
                    />
                  </div>
                ) : <div></div>}

              </div>
            </div> :
            <IonItem
              disabled={multiSelectionPermitted ? shouldBeDisabled : false}
              lines="none"
              key={makeKey(choiceIndex, sku, groupIndex)}
              onClick={() => {
                if (multiSelectionPermitted) {
                  this.handleInputChange(groupIndex, sku, multiSelectionPermitted, { target: { checked: !isChecked } }, choiceIndex);
                } else {
                  this.handleInputChange(groupIndex, sku, multiSelectionPermitted, { target: { value: choiceIndex } }, choiceIndex);
                }
              }}
            >
              <div tabIndex="-1"></div>

              {multiSelectionPermitted ? (
                <IonCheckbox
                  color="secondary"
                  slot="start"
                  checked={isChecked}
                />
              ) : (
                <IonRadio
                  slot="start"
                  className="details-radio"
                  color={'secondary'}
                  value={sku}
                  checked={isChecked}
                  name="modifier-group"
                />
              )}
              <IonLabel className="ion-text-wrap">
                <Sectiontitle className="single-item item-details-product-label">
                  {__(getProductName(item, profile))}
                </Sectiontitle>
                {isDefined(item.itemRichData) &&
                  isDefined(item.itemRichData.allergenCodes) &&
                  item.itemRichData.allergenCodes.length > 0 ? (
                  <>
                    <SmallText className='block capitalize '><span className='primary-color'>{__('Allergens')}: </span>{item.itemRichData.allergenCodes.join(' • ')}</SmallText>
                  </>
                ) : null}
              </IonLabel>
              <p>{formatPrice(productPrice)}</p>


            </IonItem>
          }


          {item.subModifiers?.length > 0 && isChecked &&
            <div className="bundle-modifiers-wrapper">
              {item.subModifiers.map((nested, nestedInded) => <>
                {this.drawSubModifiersLabel(nested, groupIndex, choiceIndex, nestedInded)}
                {
                  this.drawSubModifiers(nested, groupIndex, choiceIndex, nestedInded)}
              </>)}

            </div>
          }

        </>
      );
    });
    return <div className="item-details-group-wrapper box-wrapper box-list">{allChoices}</div>;

  };

  drawGroupLabel = (menuGroupItem, groupIndex) => {
    const { validationErrors, excludeTaxes } = this.state;
    const { __ } = this.props;
    const { description, min, max } = menuGroupItem;
    return (
      <>
        <IonItem lines="none">
          <div tabIndex="-1" className="sectiontitle">
            <StrongText>{description}</StrongText>
            <Spacer size={1} />
            <div>
              {!isDefined(min) && !isDefined(max) ? null : (
                <SmallText>
                  {isDefined(min) ? __('min') + ':' + min + ',' : null}{' '}
                  {isDefined(max) ? __('max') + ':' + max : null}
                </SmallText>
              )}
              {excludeTaxes ? (
                <SmallText className="exclude-taxes-text">{__('Exc VAT')}</SmallText>
              ) : null}
            </div>
          </div>
        </IonItem>
        {validationErrors[groupIndex] ? (
          <div className="field-error">{__(validationErrors[groupIndex])}</div>
        ) : null}
      </>
    );
  };

  drawMenuDealGroups = (menuGroupItem, index) => {
    // multiSelectionPermitted = true  --> only one item must be selected
    const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
    if (isChoicesGroupValid(menuGroupItem)) {
      if (isDefined(multiSelectionPermitted)) {
        return (
          <div className="item-details-group item-modifier-group" key={index}>
            {this.drawGroupLabel(menuGroupItem, index)}
            {this.drawGroupChoices(menuGroupItem, multiSelectionPermitted, index)}
          </div>
        );
      } else {
        return this.drawGroupLabel(menuGroupItem);
      }
    }
  };

  constructBasketItem = () => {
    const { item } = this.props;
    const { quantity, selectedChoices, instructions, selectedSubChoices } = this.state;

    return {
      item,
      quantity,
      selectedChoices,
      instructions,
      selectedSubChoices,
    };
  };

  addToOrder = () => {
    const newBasketItem = this.constructBasketItem();
    const validationErrors = validateItem(newBasketItem);
    const { item } = this.props;
    for (let i = 0; i < newBasketItem.selectedChoices.length; i++) {
      const sub = newBasketItem.selectedSubChoices[i].flat(2);
      for (let j = 0; j < sub.length; j++) {
        const parentIndex = newBasketItem.selectedChoices[i].findIndex(
          (el) => el.sku == sub[j].parentModifierSku,
        );
        newBasketItem.selectedChoices[i].splice(parentIndex + 1, 0, sub[j]);
      }
    }
    if (validationErrors.errorCount > 0) {
      this.setState({ validationErrors: validationErrors.errors }, () => {
        this.setShowValidationAlert(true);
      });
    } else {
      if (Basket.items.length === 0 && isEmptyObject(this.props.ikentooMenu)) {
        this.props.dispatch(storeItemWeb(newBasketItem));
        forwardTo('/delivery-options');
      } else {
        addToBasket(newBasketItem);
        if (isWebConfig()) {
          this.props.closeModal();
        } else {
          goBack();
        }
      }
    }

    let allergensCodes = item.itemRichData ? (item.itemRichData.allergenCodes ? item.itemRichData.allergenCodes : []) : [];
    const modifierCodes = [...new Set(newBasketItem.selectedChoices.map((group) => group.map((item) => item?.itemRichData?.allergenCodes).flat()).flat())].filter(Boolean);
    if (allergensCodes.length > 0 || modifierCodes.length > 0) {
      let allergensData = [{ allergens: this.state.allergensCodes }, { sku: item.sku }];
      if (isDefined(newBasketItem.selectedChoices)) {
        newBasketItem.selectedChoices.forEach((group) => {
          group.forEach((item) => {
            if (isDefined(item.itemRichData) && isDefined(item.itemRichData.allergenCodes) && item.itemRichData.allergenCodes.length > 0) {
              setAllergen([{ allergens: item.itemRichData.allergenCodes }, { sku: item.sku }]);
            }
          });
        });
      }
      setAllergen(allergensData);
    }

    // let allergensCodes =
    //   item &&
    //   item.itemRichData &&
    //   item.itemRichData.allergenCodes &&
    //   item.itemRichData.allergenCodes.length > 0
    //     ? item.itemRichData.allergenCodes
    //     : [];
    // if (allergensCodes.length > 0) {
    //   let allergensData = [{ allergens: this.state.allergensCodes }, { sku: item.sku }];
    //   setAllergen(allergensData);
    // }
  };

  instructionsChange = (event) => this.setState({ instructions: event.target.value });

  setShowValidationAlert = (flag) => this.setState({ showValidationAlert: flag });
  drawNutritionalInfo = (__, nutritionalInfo) => {
    return (
      <div className="nutrition-accordion-wrapper">
        {this.drawAccortianButton(
          () =>
            this.setState({
              nutritionalInfoVisible: !this.state.nutritionalInfoVisible,
              ingredientsVisible: false,
            }),
          __('Nutritional Info'),
          this.state.nutritionalInfoVisible,
        )}
        {this.state.nutritionalInfoVisible && (
          <div>
            {this.drawNutritionalTable(__, nutritionalInfo.items)}
            {this.drawAccortianButton(
              () => this.setState({ ingredientsVisible: !this.state.ingredientsVisible }),
              __('Ingredients'),
              this.state.ingredientsVisible,
            )}
            {this.state.ingredientsVisible && this.drawIngredients(nutritionalInfo.ingredients)}
          </div>
        )}
      </div>
    );
  };
  drawAccortianButton = (onClick, label, visible) => {
    return (
      <>
        <div className="accordian-button" onClick={onClick}>
          <span>{label}</span>
          <IonIcon icon={visible ? chevronUp : chevronDown} />
        </div>
      </>
    );
  };
  drawIngredients = (text) => {
    const { nutritionData } = this.props;
    if (this.state.selectedChoices.length > 0) {
      const ingredientsList = this.state.selectedChoices[0].map((el) => {
        return nutritionData.find((value) => value.sku === el.sku)?.ingredients || '';
      });
      ingredientsList.map((value) => {
        text += value;
      });
    }
    return <div className="ingredients-text" dangerouslySetInnerHTML={{ __html: text }}></div>;
  };
  drawNutritionalTable = (__, items) => {
    const { nutritionData } = this.props;
    let nutritions = items;
    if (this.state.selectedChoices.length > 0 && !isEmptyObject(this.state.selectedChoices[0])) {
      let nutritionDataItems = this.state.selectedChoices[0].map((i) => {
        return nutritionData.find((value) => value.sku === i.sku)?.items;
      });
      nutritionDataItems = !nutritionDataItems[0] ? [] : nutritionDataItems;
      const totalamount = (totalGroup, indexOfElement, sort) => {
        let sum = '';
        totalGroup.map((item) => {
          let stringToNumOfPastValue = sum.match(/[a-z]+|[^a-z]+/gi)
            ? +sum.match(/[a-z]+|[^a-z]+/gi)?.[0]
            : '';
          let additionalNut =
            item[indexOfElement][sort] === 'n/a'
              ? ''
              : +item[indexOfElement][sort].match(/[a-z]+|[^a-z]+/gi)?.[0] || 0;
          sum =
            (parseFloat(stringToNumOfPastValue + additionalNut).toFixed(2) * 100) / 100 +
            item[indexOfElement][sort].match(/[a-z]+|[^a-z]+/gi)?.[1] || '';
        });
        return sum;
      };

      nutritions = items.map((item, index) => {
        let newItem = {
          item: '',
          amountPer100: '',
          amountPerServing: '',
        };
        newItem.item = item.item;
        newItem.amountPer100 = totalamount([items, ...nutritionDataItems], index, 'amountPer100');
        newItem.amountPerServing = totalamount(
          [items, ...nutritionDataItems],
          index,
          'amountPerServing',
        );
        return newItem;
      });
    }
    return (
      <table className="nutrition-table">
        <thead>
          <tr>
            <th>{__('Table of Nutritional Information')}</th>
            <th>{__('Per 100g')}</th>
            <th>{__('Per serving')}</th>
          </tr>
        </thead>
        <tbody>
          {nutritions.map((el, i) => {
            return (
              <tr key={i}>
                <td>{el.item}</td>
                <td>{el.amountPer100}</td>
                <td>{el.amountPerServing}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };
  setNestedValue = (arr, path, newValue) => {
    // Get current value at the path
    let current = arr;
    for (let i = 0; i < path.length; i++) {
      if (!current[path[i]]) break;
      current = current[path[i]];
    }

    // If already updated, return original array
    if (current?.error === newValue.error) return arr;

    // Otherwise, update immutably
    const [index, ...rest] = path;
    return arr.map((item, i) =>
      i === index
        ? Array.isArray(item)
          ? this.setNestedValue(item, rest, newValue)
          : { ...item, ...newValue }
        : item
    );
  };
  drawSubModifiersLabel = (subModifier, groupIndex, choiceIndex, subModifierIndex) => {
    const { __ } = this.props;
    const { description, min, max } = subModifier;
    const quantity = this.state.selectedSubChoices?.[groupIndex]?.[choiceIndex]?.[subModifierIndex] ? this.state.selectedSubChoices[groupIndex][choiceIndex][subModifierIndex].reduce((sum, item) => sum + (item.quantity || 0), 0) : 0
    const { error } = Basket.validateNestedModifiers(min, max, quantity)
    nestedModifiersErrors[groupIndex][choiceIndex][subModifierIndex] = { error }
    return (
      <>
        <IonItem lines="none">
          <div tabIndex="-1" className="sectiontitle">
            <StrongText>{description}</StrongText>
            <Spacer size={1} />
            <div>
              {!isDefined(min) && !isDefined(max) ? null : (
                <SmallText>
                  {isDefined(min) ? __('min') + ':' + min + ',' : null}{' '}
                  {isDefined(max) ? __('max') + ':' + max : null}
                </SmallText>
              )}

            </div>
            {error ? (
              <div style={{ margin: '5px 0' }} className="field-error">{__(error)}</div>
            ) : null}
          </div>

        </IonItem>

      </>
    );
  };
  drawSubModifiers = (subModifier, groupIndex, choiceIndex, subModifierIndex) => {
    const { items, max, multiMax, multiSelectionPermitted } = subModifier;
    const { selectedSubChoices, orderType } = this.state;
    const { __, profile } = this.props
    const allSubChoices = items.map((item, index) => {
      const { sku } = item;
      const isChecked = !!(selectedSubChoices[groupIndex][choiceIndex][[subModifierIndex]] || []).find((i) => {
        return i.sku === sku;
      });
      const groupQuantity =
        selectedSubChoices[groupIndex][choiceIndex][subModifierIndex] &&
          selectedSubChoices[groupIndex][choiceIndex][subModifierIndex].length > 0
          ? selectedSubChoices[groupIndex][choiceIndex][subModifierIndex].reduce((sum, i) => sum + i.quantity || 0, 0)
          : 0;
      let quantity = 0;
      if (selectedSubChoices[groupIndex][choiceIndex][subModifierIndex]) {
        const _choice = selectedSubChoices[groupIndex][choiceIndex][subModifierIndex].find((i) => i.sku === sku);
        quantity = _choice ? _choice.quantity : 0;
      }
      const shouldBeDisabled =
        isDefined(max) &&
        max > 0 &&
        isDefined(selectedSubChoices[groupIndex][choiceIndex][subModifierIndex]) &&
        groupQuantity >= max &&
        !isChecked;
      const excludeTaxes = profile.is_corporate
        ? isTaxActiveForOrderType(orderType)
        : doesItemHaveTax(item);
      let productPrice = item.productPrice;
      if (excludeTaxes) {
        productPrice = parseFloat(getItemTax(item, orderType)?.calculatedTaxPrice || 0);
      }
      return (
        <div className="bundle-modifiers">
          <IonItem lines="none">
            {multiSelectionPermitted ?
              <IonCheckbox
                disabled={shouldBeDisabled || !Basket.isProductEnabled(item)}
                className="details"
                color="secondary"
                slot="start"
                checked={isChecked}
                onIonChange={(event) => {
                  Basket.isProductEnabled(item) &&
                    this.handleSubInputChange(
                      groupIndex,
                      choiceIndex,
                      index,
                      subModifierIndex,

                      multiSelectionPermitted,
                      event,
                    );
                }}
              />
              :
              <IonRadio
                disabled={!Basket.isProductEnabled(item)}
                className="details"
                color="secondary"
                slot="start"
                checked={isChecked}
                onClick={(event) => {
                  Basket.isProductEnabled(item) &&
                    this.handleSubInputChange(
                      groupIndex,
                      choiceIndex,

                      index,
                      subModifierIndex,

                      multiSelectionPermitted,
                      event,
                    );
                }}
              />

            }

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '20px' }}>
              <div style={{ flex: 1 }} className=" item-details-product-label block">
                <NormalText> {this.props.__(getProductName(item, this.props.profile))}</NormalText>
                {formatPrice(productPrice) ? (
                  <NormalText className="block">
                    <NormalText>{formatPrice(productPrice)}</NormalText>
                    <SmallText>{__(`${excludeTaxes ? ` ${__('Exc VAT')}` : ''}`)}</SmallText>
                  </NormalText>
                ) : null}
                {isDefined(item.itemRichData) &&
                  isDefined(item.itemRichData.allergenCodes) &&
                  item.itemRichData.allergenCodes.length > 0 ? (
                  <>
                    <SmallText className='block capitalize '><span className='primary-color'>{__('Allergens')}: </span>{item.itemRichData.allergenCodes.join(' • ')}</SmallText>
                  </>
                ) : null}
              </div>
              <div className="price-increment-content" style={{ width: '80px' }}>
                {quantity >= 1 && max > 1 && multiMax > 1 ? (
                  <div
                    className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                  >
                    <Incrementer
                      allowNegative={false}
                      data={{ groupIndex, choiceIndex, multiSelectionPermitted, bundleIndex: index, subModifierIndex }}
                      disabled={shouldBeDisabled}
                      maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                      onUpdate={this.onIncrementerSubChoiceUpdate}
                      quantity={quantity || 0}
                    />
                  </div>

                ) : null}
              </div>

            </div>

          </IonItem>

        </div>
      );
    });
    return allSubChoices;
  };
  onIncrementerSubChoiceUpdate = (newQuantity, data) => {
    const { item } = this.props;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[data.groupIndex].bundleModifiers[data.choiceIndex][data.subModifierIndex];
    if (selectedGroup) {
      this.updateSelectedSubChoices(
        data.groupIndex,
        data.choiceIndex,
        data.bundleIndex,
        data.subModifierIndex,
        data.multiSelectionPermitted,
        newQuantity > 0,
        newQuantity,
      );
    }
  };
  handleSubInputChange = (groupIndex, choiceIndex, bundleIndex, subModifierIndex, multiSelectionPermitted, event) => {
    event.stopPropagation();
    event.preventDefault();
    const item = this.props.item;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex].bundleModifiers[choiceIndex][subModifierIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[bundleIndex];

      this.updateSelectedSubChoices(
        groupIndex,
        choiceIndex,
        bundleIndex,
        subModifierIndex,
        multiSelectionPermitted,
        multiSelectionPermitted ? event.target.checked : !!selectedChoice,
        selectedChoice ? 1 : 0,

      );
    }
  };
  updateSelectedSubChoices = (
    groupIndex,
    choiceIndex,
    bundleIndex,
    subModifierIndex,
    multiSelectionPermitted,
    selected = true,
    quantity = 0,
  ) => {
    const { item } = this.props;
    const { selectedSubChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex].bundleModifiers[choiceIndex][subModifierIndex];

    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[bundleIndex];

      selectedChoice.parentModifierSku = allGroups[groupIndex].items[choiceIndex].sku;
      selectedChoice.bundleModifier = true;
      let updatedSelectedSubChoices = deepCopy(selectedSubChoices);
      let selectedSubChoiceIndex = -1;
      const existingChoice = updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex].find((i, index) => {
        if (selectedChoice && i.sku === selectedChoice.sku) {
          selectedSubChoiceIndex = index;
          return true;
        }
        return false;
      });

      if (multiSelectionPermitted) {
        if (selected) {
          selectedChoice.quantity = 1;
          if (existingChoice) {
            existingChoice.quantity = quantity;
            if (
              selectedSubChoiceIndex !== -1 &&
              updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex] &&
              updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex][selectedSubChoiceIndex]
            ) {
              updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex][
                selectedSubChoiceIndex
              ] = existingChoice;
            }
          } else {
            updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex].push(selectedChoice);
          }
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex] = updatedSelectedSubChoices[
            groupIndex
          ][choiceIndex][subModifierIndex].filter((i) => i.sku !== selectedChoice.sku);
        }
      } else {
        if (selected) {
          if (existingChoice) {
            updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex] = updatedSelectedSubChoices[
              groupIndex
            ][choiceIndex][subModifierIndex].filter((i) => i.sku !== selectedChoice.sku);
          } else {
            selectedChoice.quantity = 1;
            updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex] = []
            updatedSelectedSubChoices[groupIndex][choiceIndex][subModifierIndex].push(selectedChoice);
          }
        }
      }
      this.setState({ selectedSubChoices: updatedSelectedSubChoices }, () => {
        const validationErrors = validateItem(this.constructBasketItem());
        this.setState({ validationErrors: validationErrors.errors });
      });
    }
  };

  render() {
    const { __, profile, hideIncrementer, item, nutritionData } = this.props;
    const {
      quantity,
      price,
      showValidationAlert,
      allergensCodes,
      excludeTaxes,
      orderType,
    } = this.state;
    const menuDealGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const nestedErrors = [...nestedModifiersErrors].flat(2).filter(el => el.error)
    const isAddToOrderBtnValid = validateItem(this.constructBasketItem()).errorCount === 0 && nestedErrors.length === 0;
    const itemSku = item.sku && item.sku.split('-#')[0];
    const nutritionalInfo = nutritionData.find((el) => el.sku === itemSku) || null;
    let productPrice = item.productPrice;
    if (excludeTaxes) {
      productPrice = parseFloat(getItemTax(item, orderType)?.calculatedTaxPrice || 0);
    }
    return (
      <>
        <div className="item-details-card-content">
          <IonList className="item-details-card-list">
            {!isWebConfig() &&

              <>
                <NormalText
                  className="item-details-card-description"
                  dangerouslySetInnerHTML={{
                    __html: getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
                  }}
                ></NormalText>
                <div className="item-details-card-price okx-font-secondary">
                  {`${formatPrice(productPrice)} `}
                  <StrongText>{__(`${excludeTaxes ? __('Exc VAT') : ''}`)}</StrongText>
                </div>
                {allergensCodes.length > 0 ? (
                  <>
                    <StrongText>{__('Allergens')}</StrongText>
                    <IonItem lines="none">
                      <div tabIndex="-1"></div>
                      <PillGroup items={allergensCodes} borderColor="primary" />
                    </IonItem>
                  </>
                ) : null}

                {nutritionalInfo && this.drawNutritionalInfo(__, nutritionalInfo)}
              </>}

            {menuDealGroups.map(this.drawMenuDealGroups)}
            {/* <IonItem lines="none">
							<Sectiontitle><strong>{ __('Special Instructions')}</strong> <span className="normal-text">{ __('Optional')}</span></Sectiontitle>
						</IonItem>
						<IonItem>
							<IonTextarea onIonChange={ this.instructionsChange } rows={ 1 } placeholder={ __('E.g No onions, etc')}></IonTextarea>
						</IonItem> */}
            {/* {getConfig().flags &&
            getConfig().flags.specialInstructions &&
            getConfig().flags.specialInstructions.isDisplayed ? (
              <>
                <IonItem lines="none">
                  <div tabIndex="-1"></div>
                  <Sectiontitle>
                    {__('Special Instructions')}{' '}
                    <span className="normal-text">{__('Optional')}</span>
                  </Sectiontitle>
                </IonItem>
                <IonItem>
                  <IonTextarea
                    onIonChange={this.instructionsChange}
                    rows={1}
                    placeholder={__(getConfig().flags.specialInstructions.placeholder)}
                  ></IonTextarea>
                </IonItem>
              </>
            ) : null} */}
          </IonList>
          {hideIncrementer ? null : (
            <div className="item-details-actions flex-col-wrapper flex-align-center flex-justify-between">
              <Incrementer
                allowNegative={false}
                quantity={quantity}
                onUpdate={this.onIncrementerUpdate}
              />
              <FlexSpacer size={20} />
              <IonButton
                disabled={quantity === 0 || !isAddToOrderBtnValid}
                className="item-details-add-to-order"
                size="full"
                shape="round"
                onClick={this.addToOrder}
              >
                {Basket.items.length === 0 && isEmptyObject(this.props.ikentooMenu)
                  ? __('Start New Order')
                  : __('Add to Order')}
              </IonButton>
            </div>
          )}
        </div>
        <IonAlert
          isOpen={showValidationAlert}
          onDidDismiss={() => this.setShowValidationAlert(false)}
          header={__('Validation')}
          message={__('Please check any required options')}
          buttons={[{ text: __('OK'), role: 'cancel', cssClass: 'secondary' }]}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    profile: store.profile.profile,
    restaurantsUpdated: store.restaurants.restaurantsUpdated,
    basketUpdated: store.orders.basketUpdated,
    allergens: store.restaurants.allergens,
    nutritionData: store.restaurants.nutrition_data || [],
    storedItemWeb: store.orders.storedItemWeb,
    ikentooMenu: store.restaurants.ikentooMenu || {},
  };
};

export const ItemDetailsRaw = connect(mapStateToProps)(withTranslation(itemDetailsContent));

class itemDetails extends Component {
  constructor(props) {
    super(props);
    this.x = React.createRef();
    this.state = {
      nameVisible: true,
    };
  }
  onContentScrollHandler() {
    if (!this.isScrolledIntoView(this.x.current)) {
      this.setState({ nameVisible: false });
    } else {
      this.setState({ nameVisible: true });
    }
  }
  isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
    return isVisible;
  }
  shouldComponentUpdate(prevProps, prevState) {
    if (this.state.nameVisible !== prevState.nameVisible) {
      return true;
    } else {
      return false;
    }
  }
  render() {
    const { history, location, __, profile } = this.props;
    const item = location.state;
    const image =
      item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';

    const { selectedMenu } = item;

    return (
      <Layout
        headerTitle={__('Item Details')}
        scrollY={false}
        noPadding
        contentClassName="item-details-wrapper"
        hideSecondToolbar={true}
      >
        <div className="item-details-main-wrapper">
          <div
            className={
              this.state.nameVisible ? ' item-details-header' : 'active item-details-header'
            }
          >
            <div className="item-details-back">
              <IonButton
                className="solo-button"
                color="white"
                onClick={() => forwardTo('/order', { selectedMenu })}
              >
                <IonIcon slot="icon-only" icon={arrowBack} />
              </IonButton>
            </div>
            <div
              style={{
                transition: !this.state.nameVisible ? 'transform 0.3s ease-in-out' : 'none',
                display: 'flex',
                alignItems: 'center',
                transform: this.state.nameVisible ? 'translateY(-250%)' : 'translateY(0)',
              }}
            >
              <NormalText style={{ fontSize: '18px' }}>
                <strong> {__(getProductName(item, profile))}</strong>
              </NormalText>
            </div>
          </div>
          <div
            className="scrollable-y item-detals-background"
            onScroll={() => {
              this.onContentScrollHandler();
            }}
          >
            <div className="item-details-info">
              {image && image !== '' ? (
                <div className="item-details-img">
                  <img src={image} />
                </div>
              ) : (
                <div className="image-placeholder"></div>
              )}
              <div className="item-details-name" ref={this.x}>
                <Title> {__(getProductName(item, profile))}</Title>
              </div>
            </div>

            <ItemDetailsRaw item={item} profile={profile} />
          </div>
        </div>
      </Layout>
    );
  }
}

const stateToProps = (store) => {
  return {
    profile: store.profile.profile,
  };
};

export default connect(stateToProps)(withTranslation(itemDetails));
